import React, { Component } from 'react';
import './style.css';

class CouponListView extends Component {
  constructor(props){
    super(props)
    this.state={
    };
    this.editMember = this.editMember.bind(this);
  }

  editMember(data){
    this.props.editMember(data);
  }
  createCoupon(){
      this.props.createCouponView()
  }

  render(){

    let couponsDataList = "";
    if(this.props.couponListSuccess){
    if(this.props.couponListData && this.props.couponListData.couponList.length){
        let coupons = this.props.couponListData.couponList;
        couponsDataList = Object.keys(coupons).map((item, index) => {
        let couponsItem = coupons[item];

        return <tr key={index} >
          <td>{index+1}</td>
          <td>{couponsItem.Coupon_code}</td>
          <td>{couponsItem.Coupon_type}</td>
          <td>{couponsItem.Description}</td>
          <td>{couponsItem.Expire_date.split("T")[0]}</td>
          <td>{couponsItem.Coupon_amount}</td>
          <td>{couponsItem.Coupon_status}</td>
          </tr>
          });
    }
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Coupon List</h1></div>
     <button  className = "createCouponbtn"  onClick={this.createCoupon.bind(this)}>Create coupon</button>
        <div className = "autoscroll">
        <table className = "couponTable">
          <thead>
            <tr >
              <th >Sr.No.</th>
              <th>Coupon Code</th>
              <th>Coupon Type</th>
              <th>Description</th>
              <th>Expire_date</th>
              <th>Coupon_amount</th>
              <th>Coupon_status</th>
            </tr>
          </thead>
            <tbody> 
              {couponsDataList}  
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default CouponListView;



// WEBPACK FOOTER //
// ./src/components/coupon/couponList.js